<template>
  <div class="read-history-box">
    <van-nav-bar :border="false" fixed>
      <template #left><van-icon @click="goBack" name="arrow-left back-icon"/></template>
      <template #title>
        <div class="nav-title">Viewed</div>
      </template>
    </van-nav-bar>
    <NvBookGrid :books="books" />
  </div>
</template>

<script>
import { getLocalReadProgress, batchGetBookInfo } from "@/service/api";
import NvBookGrid from "@/components/layout/NvBookGrid";

export default {
  components: {
    NvBookGrid
  },
  data() {
    return {
      bookIds: [],
      books: []
    };
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    getReadHistoryList() {
      const books = getLocalReadProgress();
      this.bookIds = books.map(b => b.book_id);
      this.getBooksInfo(this.bookIds);
    },
    getBooksInfo(bookIds) {
      batchGetBookInfo({ book_ids: bookIds }).then(res => {
        this.books = res;
      });
    }
  },
  mounted() {
    this.getReadHistoryList();
    window.$event("History_Show", {});
  }
};
</script>

<style lang="scss" scoped>
.read-history-box {
  .back-icon {
    font-size: 20px;
    color: $fc-black;
  }
  .nav-title {
    font-size: $fs-l;
    color: $fc-black;
  }
  .book-list {
    margin-top: 45px;
    display: flex;
    justify-content: center;
    .book-list-content {
      margin: 32px 16px;
      .book-box {
        padding: 0 5px;
        float: left;
        width: calc((100vw - 32px - 30px) / 3);
        margin-bottom: 16px;
        &.book-add-box {
          background: $bg-main;
          border-radius: 6px;
          height: 9rem;
          .icon-big {
            font-size: 50px;
            color: $fc-grey;
          }
        }
      }
    }
  }
}
</style>
